//对cp中get_account_id、get_location_info、is_login的方法二次Promise封装
export function userInfoAction(){
  //JSSDK方法回调超时时间；
  let timeOut = {
    accountId : 2000,
    sessionId: 2000,
  }
  //JSSDK 回调Promise
  let accountId = function(){
    return new Promise((resolve,reject)=>{
      try{
        CP.get_account_id((data)=>{
          resolve({
            name:'account_id',
            data:{
              account_id:data.account_id || -1,
            },
            code:1,
          })
        })
      }catch(err){
        reject({
          message:`Get Account Id Err:${err.message}`
        })
      }
      setTimeout(()=>{
        resolve({
          name:'account_id',
          data:-1,
          code:0,
        })
      },timeOut.accountId)
    });
  }
  let sessionId = function(){
    return new Promise((resolve,reject)=>{
        try{
          CP.get_unique_id((data)=>{
            resolve({
              name:'session_id',
              data:{
                session_id:data.unique_id || -1,
              },
              code:1,
            })
          })
        }catch(err){
          reject({
            message:`Get session Id Err:${err.message}`
          })
        }
        setTimeout(()=>{
            resolve({
              name:'session_id',
              data:-1,
              code:0,
            })
        },timeOut.sessionId)
      });
  }
  let deviceInfo = function() {
    return new Promise((resolve,reject)=>{
        try{
          CP.get_device_info({
            completed: function(data) {
                resolve({
                    name:'deviceInfo',
                    data,
                    code:1,
                  })
            },
            once: true,
            cp_incompatible: function () {
                resolve({
                    name:'deviceInfo',
                    data:-1,
                    code:0,
                  })
            }
          })

        }catch(err){
          reject({
            message:`Get deviceInfo Err:${err.message}`
          })
        }
        setTimeout(()=>{
            resolve({
              name:'deviceInfo',
              data:-1,
              code:0,
            })
        },timeOut.sessionId)
      });
  }
  return {
    accountId,sessionId,deviceInfo
  }
}
